import { render, staticRenderFns } from "./IndustryInformationList.vue?vue&type=template&id=0b57ece8&scoped=true&"
import script from "./IndustryInformationList.vue?vue&type=script&lang=js&"
export * from "./IndustryInformationList.vue?vue&type=script&lang=js&"
import style0 from "./IndustryInformationList.vue?vue&type=style&index=0&id=0b57ece8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b57ece8",
  null
  
)

export default component.exports